module.exports = __webpack_public_path__ + "img/sixpackcarrier24.d6d2be92.jpg";